module.exports = __webpack_public_path__ + "media/images/logo_128-0d0bfda8.png";